import React, { useMemo } from "react";
import styles from "./hidden.module.css";

function Hidden({
  lgDown,
  mdDown,
  smDown,
  xsDown,
  lgUp,
  mdUp,
  smUp,
  xsUp,
  xlUp,
  children,
  className,
  ...props
}) {
  const appliedStyles = useMemo(() => {
    return [
      styles.hidden,
      lgDown && styles.hiddenLgDown,
      mdDown && styles.hiddenMdDown,
      smDown && styles.hiddenSmDown,
      xsDown && styles.hiddenXsDown,
      lgUp && styles.hiddenLgUp,
      mdUp && styles.hiddenMdUp,
      smUp && styles.hiddenSmUp,
      xsUp && styles.hiddenXsUp,
      xlUp && styles.hiddenXlUp,
      className,
    ]
      .filter(Boolean)
      .join(" ");
  }, [lgDown, mdDown, smDown, xsDown, lgUp, mdUp, smUp, xsUp, xlUp, className]);
  return (
    <div {...props} className={`${appliedStyles} `}>
      {children}
    </div>
  );
}

export default Hidden;
